import script from "./TermsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsView.vue?vue&type=script&setup=true&lang=js"

import "./TermsView.vue?vue&type=style&index=0&id=4fedde64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fedde64"]])

export default __exports__